import { Program } from "@platform/types/dashboard.types";
import {
  User,
  Organization,
  PhaseAction,
} from "@platform/types/platform.types";
import { makeContext } from "@shared/utils/makeContext";

// --- Name ---
const NAME = "Program";

// --- Types ---
export type ProgramState = {
  program?: Program | null;
  user?: User | null;
  organization?: Organization | null;
  isLoading?: boolean;
  userPhaseActions?: PhaseAction[];
};

export type ProgramAction = {
  type: string;
  payload?: Partial<ProgramState>;
};

// --- Constants ---
export const PROGRAM_MOUNT = "program/mount" as const;
export const PROGRAM_PHASES_SET = "programPhases/set" as const;
export const USER_PHASE_ACTIONS_SET = "userPhaseActions/set" as const;

export const ACTION_TYPES = {
  PROGRAM_MOUNT,
  PROGRAM_PHASES_SET,
  USER_PHASE_ACTIONS_SET,
} as const;

// --- Initial State ---
export const initialProgram: ProgramState = {
  program: null,
  user: null,
  organization: null,
  isLoading: true,
  userPhaseActions: [],
};

// --- Reducer ---
function programReducer(
  state: ProgramState,
  action: ProgramAction
): ProgramState {
  switch (action.type) {
    case ACTION_TYPES.PROGRAM_PHASES_SET:
      return {
        ...state,
        program: action.payload as Program,
      };
    case ACTION_TYPES.PROGRAM_MOUNT:
      return {
        ...state,
        program: action.payload?.program as Program,
        user: action.payload?.user as User,
        organization: action.payload?.organization as Organization,
        isLoading: false,
      };
    default:
      return state;
  }
}

// --- Context Creation ---
export const {
  Provider: ProgramProvider,
  useState: useProgram,
  useDispatch: useProgramDispatch,
} = makeContext<ProgramState, ProgramAction>({
  name: NAME,
  initialState: initialProgram,
  reducer: programReducer,
});
